import {CWDetection, FontSizeConstants, normalizeFontName, pixelStrToRemStr} from '@transparent/coretypes';

const CJ_FONT = 'SimHei';

/**
 * Utility method for getting fon faces
 * {String} fontName Name of the font
 * {string} String containing supported font faces
 */
export function getFontFaces(fontName: string): string {
    switch (fontName) {
        case 'Latin':
            return 'rbim'; // regular bold italic boldItalic
        case 'Arabic':
        case 'Baluchi':
        case 'Pashto':
        case 'Persian':
        case 'Urdu':
        case 'Burmese':
            return 'rb';
        default:
            return 'r';
    }
}

export function getNormalFontFaceCss(fontUrl = 'fonts/', fontName: string): string {
    return `@font-face {
            font-family: ${fontName};
            src: url(${fontUrl + fontName}.ttf) format('truetype');
            font-weight: normal;
            font-style: normal;
        }\n`;
}

export function getBoldFontFaceCss(fontUrl = 'fonts/', fontName: string): string {
    return ` @font-face {
            font-family: ${fontName};
            src: url(${fontUrl + fontName}Bold.ttf) format('truetype');
            font-weight: bold;
            }\n`;
}

export function getItalicFontFaceCss(fontUrl = 'fonts/', fontName: string): string {
    return ` @font-face {
            font-family: ${fontName};
            src: url(${fontUrl + fontName}Italic.ttf) format('truetype');
            font-style: italic;
            }\n`;
}

export function getBoldItalicFontFaceCss(fontUrl = 'fonts/', fontName: string): string {
    return ` @font-face {
            font-family: ${fontName};
            src: url(${fontUrl + fontName}BoldItalic.ttf) format('truetype');
            font-weight: bold;
            font-style: italic;
            }\n`;
}

export function getFontClass(fontName: string, className: string, direction: string): string {
    let fontSize = FontSizeConstants.getDefault(fontName) + 'px';
    // if (CWDetection.isIOS && CWDetection.isPhone && CWDetection.isSafari) {
    if (CWDetection.isIOS) {
        fontSize = pixelStrToRemStr(fontSize);
    }
    return ` .${className} {
            font-family: ${fontName} !important;
            direction: ${direction};
            font-size: ${fontSize};
        }\n`;
}

/**
 * Generates css based on config and attaches it to head
 */
export function insertFontCss(fontName: string, className = 'uiFont',
                              direction = 'ltr', locale = 'en_US',
                              fontUrl = 'fonts/', doc: Document = null): void {
    doc = doc || document;
    const head: HTMLElement = doc.getElementsByTagName('head')[0] as HTMLElement;
    const perStyle = doc.getElementById(className);
    const fontCss = getCssFontFace(fontName, className, direction, fontUrl);
    const root: HTMLElement = doc.getElementsByTagName('html')[0] as HTMLElement;
    if (className === 'uiFont') {
        const newLang = locale.substr(0, 2);
        if (root.lang !== newLang) {
            root.lang = newLang;
        }
        if (root.dir !== direction) {
            root.dir = direction;
        }
    }
    // Check if it is same and do not reload font if it is there
    if (perStyle && perStyle.innerHTML === fontCss) {
        return;
    }
    if (perStyle) {
        perStyle.innerHTML = fontCss;
    } else {
        const lastStyle: HTMLElement = head.getElementsByTagName('style')[0] as HTMLElement;
        const sheet = doc.createElement('style');
        sheet.innerHTML = fontCss;
        sheet['type'] = 'text/css';
        sheet.id = className;
        if (lastStyle) {
            head.insertBefore(sheet, lastStyle);
        } else {
            head.appendChild(sheet);
        }
    }
}

/**
 * Generates css based on fontName, className  and direction
 */
export function getCssFontFace(fontName: string, className = 'uiFont', direction = 'ltr', fontUrl = 'fonts/'): string {
    fontName = normalizeFontName(fontName);
    const fontFaces = getFontFaces(fontName);
    const isBold = fontFaces.indexOf('b') !== -1;
    const isItalic = fontFaces.indexOf('i') !== -1;
    const isBoldItalic = fontFaces.indexOf('m') !== -1;
    let fontStr = '';
    if (fontName !== CJ_FONT) {
        fontStr = getNormalFontFaceCss(fontUrl, fontName);
        if (isBold) {
            fontStr += getBoldFontFaceCss(fontUrl, fontName);
        }
        if (isItalic) {
            fontStr += getItalicFontFaceCss(fontUrl, fontName);
        }
        if (isBoldItalic) {
            fontStr += getBoldItalicFontFaceCss(fontUrl, fontName);
        }
    }
    return fontStr + getFontClass(fontName, className, direction);
}
